import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col, Card, CardHeader, CardBody, Alert, Label } from "reactstrap";
import { DataTable, ExportCSV } from "../../../../components";
import {
  getServiceDetailsBalance,
  getServiceNamesBalance,
} from "../../../../store/report/actions";
import { layout, roles, messages } from "../../../../common/constants";
import MediaQuery from "react-responsive";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import "react-dates/lib/css/_datepicker.css";
import * as columns from "./_columns";
import { selectServiceDetailsBalanceColumms } from "../../../../store/report/selector";
import { formatHelper } from "../../../../common/helpers";
import {
  getServiceNamesBalance as servicesBalanceExport,
  getServiceDetailsBalance as servicesBalanceDetailedExport,
} from "../../../../service/report";
import { getStores } from "../../../../store/store/actions";
import { selectUserRole } from "../../../../store/user/selector";
import { selectStoresForSelect } from "../../../../store/store/selector";
import Select from "react-select";
import { exportExcelGeneral, exportExcel } from "./excel";

class ServiceBalance extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      pageDetails: 1,
      pageNames: 1,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainDetailedReportExport =
      this.handleObtainDetailedReportExport.bind(this);
    this.handleObtainReportExport = this.handleObtainReportExport.bind(this);

    this.handlePageDetailsChange = this.handlePageDetailsChange.bind(this);
    this.handlePageNamesChange = this.handlePageNamesChange.bind(this);
    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });

    if (
      this.state.startDate &&
      this.state.endDate &&
      this.state.selectedStore
    ) {
      this.props.getServiceDetailsBalance({
        page: this.state.pageDetails,
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
      this.props.getServiceNamesBalance({
        page: this.state.pageNames,
        startDate: this.state.startDate._d,
        endDate: this.state.endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async handlePageChange(page) {
    await this.setState({ page: page });
    this.performGetServiceBalance();
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handleServiceBalanceDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null) {
      this.props.getServiceDetailsBalance({
        page: this.state.pageDetails,
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
      this.props.getServiceNamesBalance({
        page: this.state.pageNames,
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  performGetServiceBalance(reset = false, getServiceBalance, page) {
    const store = this.state.selectedStore.value;
    getServiceBalance({
      page,
      startDate: this.state.startDate._d,
      endDate: this.state.endDate._d,
      store,
      reset,
    });
  }

  async handlePageDetailsChange(pageDetails) {
    await this.setState({ pageDetails: pageDetails });
    this.performGetServiceBalance(
      false,
      this.props.getServiceDetailsBalance,
      this.state.pageDetails
    );
  }
  async handlePageNamesChange(pageTypes) {
    await this.setState({ pageTypes: pageTypes });
    this.performGetServiceBalance(
      false,
      this.props.getServiceNamesBalance,
      this.state.pageTypes
    );
  }

  renderDataTable(
    columns,
    data,
    page,
    total,
    pageSize,
    loading,
    handlePageChange
  ) {
    return (
      <DataTable
        data={data}
        keyField="id"
        columns={columns}
        page={page}
        totalSize={total}
        sizePerPage={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
      />
    );
  }

  handleObtainDetailedReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    servicesBalanceDetailedExport(
      0,
      startDate._d,
      endDate._d,
      selectedStore.value
    )
      .then((response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  handleObtainReportExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    servicesBalanceExport(0, startDate._d, endDate._d, selectedStore.value)
      .then((response) => {
        exportExcelGeneral(
          response.data.data,
          selectedStore,
          startDate,
          endDate
        );
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const { startDate, endDate, pageDetails, pageNames, loadingExport } =
      this.state;
    const {
      serviceDetailsBalance,
      totalDetails,
      pageSizeDetails,
      loadingDetails,
      serviceNamesBalance,
      totalNames,
      pageSizeNames,
      loadingNames,
    } = this.props;
    return (
      <div>
        <Card>
          <CardHeader>
            <i className="icon-chart" />
            Balance por Servicios
          </CardHeader>
          <CardBody>
            {(this.props.role == roles.SUPER_ADMIN ||
              this.props.role == roles.ADMIN) && (
              <Row className="my-4">
                <Col sm="1">
                  <Label className="mt-2">Tienda:</Label>
                </Col>

                <Col sm="4">
                  <Select
                    className="basic-single"
                    classNamePrefix="select"
                    isLoading={this.props.loadingStores}
                    isSearchable={true}
                    noOptionsMessage={() => {
                      return messages.SELECT_NO_OPTIONS;
                    }}
                    placeholder=""
                    options={this.props.stores}
                    loadingMessage={() => {
                      return messages.SELECT_LOADING;
                    }}
                    onChange={this.handleStoreChange}
                    value={this.state.selectedStore}
                    isDisabled={
                      this.props.loadingStores || loadingDetails || loadingNames
                    }
                  />
                </Col>
              </Row>
            )}

            <Row className="mb-2">
              <Col md="5">
                <DateRangePicker
                  startDate={startDate}
                  startDateId="startDate"
                  endDate={endDate}
                  endDateId="endDate"
                  displayFormat={"DD/MM/YYYY"}
                  disabled={
                    this.props.loadingStores || loadingDetails || loadingNames
                  }
                  onDatesChange={({ startDate, endDate }) =>
                    this.handleServiceBalanceDateChange(startDate, endDate)
                  }
                  focusedInput={this.state.focusedInput}
                  onFocusChange={(focusedInput) =>
                    this.setState({ focusedInput })
                  }
                  startDatePlaceholderText="Fecha Inicio"
                  endDatePlaceholderText="Fecha Fin"
                  small
                  isOutsideRange={() => false}
                  hideKeyboardShortcutsPanel
                  minimumNights={0}
                />
              </Col>
              <Col md="7">
                {this.state.startDate && this.state.endDate ? (
                  <Row>
                    <Col md="12">
                      <ExportCSV
                        disabled={loadingExport}
                        exportCSV={this.handleObtainReportExport}
                        minWidth={800}
                      />
                      <ExportCSV
                        disabled={loadingExport}
                        exportCSV={this.handleObtainDetailedReportExport}
                        minWidth={800}
                        detailed={true}
                      />
                    </Col>
                  </Row>
                ) : null}
              </Col>
            </Row>
            <hr className="my-4" />
            {startDate != null && endDate != null ? (
              <Row>
                <Col>
                  <Row className="mb-2">
                    <Col>
                      <b>Total de Ventas (S/):</b>{" "}
                      {formatHelper.toMoney(this.props.totalBought)}
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsServiceDetailsXS,
                          serviceDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsServiceDetailsSM,
                          serviceDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsServiceDetailsMD,
                          serviceDetailsBalance,
                          pageDetails,
                          totalDetails,
                          pageSizeDetails,
                          loadingDetails,
                          this.handlePageDetailsChange
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                  <hr className="my-4" />
                  <Row>
                    <Col>
                      <MediaQuery maxWidth={layout.XS_MAX_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsServiceNamesXS,
                          serviceNamesBalance,
                          pageNames,
                          totalNames,
                          pageSizeNames,
                          loadingNames,
                          this.handlePageNamesChange
                        )}
                      </MediaQuery>
                      <MediaQuery
                        minWidth={layout.SM_MIN_WIDTH}
                        maxWidth={layout.MD_MAX_WIDTH}
                      >
                        {this.renderDataTable(
                          columns.columnsServiceNamesSM,
                          serviceNamesBalance,
                          pageNames,
                          totalNames,
                          pageSizeNames,
                          loadingNames,
                          this.handlePageNamesChange
                        )}
                      </MediaQuery>
                      <MediaQuery minWidth={layout.LG_MIN_WIDTH}>
                        {this.renderDataTable(
                          columns.columnsServiceNamesMD,
                          serviceNamesBalance,
                          pageNames,
                          totalNames,
                          pageSizeNames,
                          loadingNames,
                          this.handlePageNamesChange
                        )}
                      </MediaQuery>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col>
                  <Alert color="info">
                    Seleccione un rango de fechas para visualizar los datos
                  </Alert>
                </Col>
              </Row>
            )}
          </CardBody>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const serviceDetailsBalanceList = state.report.serviceDetailsBalanceList;
  const serviceNamesBalanceList = state.report.serviceNamesBalanceList;
  return {
    serviceDetailsBalance: selectServiceDetailsBalanceColumms(state),
    totalBought: serviceDetailsBalanceList.totalBought,
    totalDetails: serviceDetailsBalanceList.total,
    pageSizeDetails: serviceDetailsBalanceList.pageSize,
    errorDetails: serviceDetailsBalanceList.error,
    loadingDetails: serviceDetailsBalanceList.loading,

    serviceNamesBalance: serviceNamesBalanceList.serviceNamesBalance,
    totalNames: serviceNamesBalanceList.total,
    pageSizeNames: serviceNamesBalanceList.pageSize,
    errorNames: serviceNamesBalanceList.error,
    loadingNames: serviceNamesBalanceList.loading,
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getServiceDetailsBalance,
      getServiceNamesBalance,
      getStores,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ServiceBalance);



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/ServiceBalance/ServiceBalance.js